module.exports = __webpack_public_path__ + "img/3200_CT_2022_Icon.7a183d7f.png";